import { getAssetFromKV, mapRequestToAsset } from '@cloudflare/kv-asset-handler'

addEventListener('fetch', event => {
  event.respondWith(handleRequest(event.request))
})

async function handleRequest(request) {
  const url = new URL(request.url)
  
  try {
    // Try to get the asset from KV storage
    return await getAssetFromKV(
      {
        request,
        waitUntil(promise) {
          return event.waitUntil(promise)
        }
      },
      {
        ASSET_NAMESPACE: STATIC_CONTENT,
        ASSET_MANIFEST: {},
        mapRequestToAsset: handleAssetRequest
      }
    )
  } catch (e) {
    // If asset not found, serve index.html for SPA routing
    if (e.status === 404) {
      const indexHtml = await STATIC_CONTENT.get('index.html')
      if (indexHtml) {
        return new Response(indexHtml, {
          headers: {
            'Content-Type': 'text/html; charset=utf-8',
            'Cache-Control': 'no-cache'
          }
        })
      }
    }
    
    // Return 404 if not found
    return new Response('Not Found', { 
      status: 404,
      headers: {
        'Content-Type': 'text/plain'
      }
    })
  }
}

function handleAssetRequest(request) {
  const url = new URL(request.url)
  const pathname = url.pathname
  
  // Handle root path
  if (pathname === '/') {
    return new Request(`${url.origin}/index.html`, request)
  }
  
  // Handle static assets
  if (pathname.startsWith('/static/')) {
    return request
  }
  
  // For SPA routing, serve index.html for non-asset paths
  if (!pathname.includes('.')) {
    return new Request(`${url.origin}/index.html`, request)
  }
  
  return request
}